import AiDevelopmentProjectsPage from "../../pages/aiDevelopment/AiDevelopmentProjectsPage";
const route={key:"aiDevelopmentProjects",path:"/ai-development/projects",component:AiDevelopmentProjectsPage,permission:"ai.development.admin",private:true,layout:"main",icon:"faFolderTree",group:"aiDevelopment",order:20};
export default route;
